/**
 * Copy for the sticky confirm bar, by flight state.
 *
 * Pure and outside the component so the states can be pinned in a test. The
 * bar is the one surface that always speaks the next action, so it is where a
 * mid-round format change gets announced — and states expressed as nested
 * conditionals inside JSX are easy to get subtly wrong. The previous version
 * carried a `Leverer…` branch that could never be reached, because the
 * submitting copy belongs to `SubmitSheet`, which covers the bar while the
 * mutation runs.
 */
export type ScoreBarState = {
  /** Every hole of every entry in the flight has a score. */
  allHolesScored: boolean
  /** Every entry in the flight has a score on the hole being shown. */
  allScoredCurrentHole: boolean
  /** Next hole in the play rotation, or null on the last one. */
  nextHole: number | null
}

export const scoreBarLabel = ({
  allHolesScored,
  allScoredCurrentHole,
  nextHole,
}: ScoreBarState): string => {
  // A complete card always offers the terminal commit, even on a hole that
  // could otherwise advance — there is nowhere left to advance to.
  if (allHolesScored) return 'Lever scorekortet'
  if (!allScoredCurrentHole) return 'Fyll ut alle slag i flighten'
  if (nextHole != null) return `Bekreft og gå til hull ${nextHole}`
  return 'Bekreft'
}
